<div class="loader-overlay" *ngIf="isLoading">
    <div class="spinner"></div>
  </div>